<template>
    <div v-if="user">
        <h2>{{ $t('tabheaders.user_info') }}</h2>
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">{{ user.user_name }}</h5>
                <p class="card-text">{{ $t('email') }}: {{ user.email }}</p>
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ $t('dataheaders.group') }}</th>
                            <th>{{ $t('activity_log_emails') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="group in userGroups" :key="group.group_id">
                            <td>{{ group.group_name }}</td>
                            <td>
                                <input type="checkbox" v-model="group.log_status"
                                    @change="toggleActivityLogEmails(group)" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-primary" @click="saveActivityLogEmails" :disabled="edited.length == 0">{{
                    $t('apply') }}</button>
                <div v-if="group_message" :class="alertClass">{{ group_message }}</div>
            </div>
        </div>
        <div class="card mt-3">
            <div class="card-body">
                <h5 class="card-title">{{ $t('change_email') }}</h5>
                <div class="form-group">
                    <label for="newEmail">{{ $t('new_email') }}</label>
                    <div class="input-group mt-2">
                        <input type="email" class="form-control" id="newEmail" v-model="newEmail">
                        <button class="btn btn-primary" id="button-addon1" @click="changeEmail"
                            :disabled="newEmail == ''">{{ $t('apply') }}</button>
                    </div>
                    <div v-if="email_message" :class="alertClass">{{ email_message }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie } = require('@/helpers');
import { fetchData } from '@/helpers';
import axios from 'axios';

export default {
    name: 'UserInfo',
    props: {
        user: {
            type: Object,
            required: true
        },
        groups: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            userGroups: [],
            newEmail: '',
            edited: [],
            group_message: '',
            email_message: '',
            alertClass: ''
        }
    },
    watch: {
        user: {
            immediate: true,
            handler(newUser) {
                if (newUser && newUser.user_id) {
                    this.fetchUserGroups(newUser);
                }
            }
        }
    },
    methods: {
        fetchData,
        async fetchUserGroups(user) {
            if (user) {
                this.userGroups = await this.fetchData('usergroups', { user_id: user.user_id });
                this.userGroups.forEach(group => {
                    group.group_name = this.groups.find(g => g.group_id === group.group_id).group_name;
                });
            }
        },
        setAlertClass(success) {
            this.alertClass = success ? 'alert alert-success' : 'alert alert-danger';
        },
        isValidEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        async changeEmail() {
            if (this.isValidEmail(this.newEmail)) {
                this.message = '';
                try {
                    await axios.post(`${this.$url}/users`,
                        {
                            email: this.newEmail,
                            user_id: this.user.user_id,
                            action: 'update'
                        },
                        {
                            headers: {
                                Authorization: 'Bearer ' + getCookie('token'),
                                'Content-Type': 'application/json'
                            }
                        });
                    this.setAlertClass(true);
                    this.email_message = this.$t('success');
                    // Display message for 3 seconds, then erase the message and reset newEmail
                    setTimeout(() => {
                        this.message = '';
                        this.email_message = '';
                        this.newEmail = '';
                    }, 3000);
                } catch (error) {
                    this.setAlertClass(false);

                    if (error.response && error.response.data) {
                        this.email_message = this.$t('error') + ': ' + error.response.data;
                    } else {
                        this.email_message = this.$t('error') + ': ' + error.message;
                    }
                }
            } else {
                this.setAlertClass(false);
                this.message = this.$t('invalid_email');
            }
        },
        toggleActivityLogEmails(group) {
            this.group_message = '';
            if (!this.edited.includes(group)) {
                this.edited.push(group);
            } else {
                this.edited = this.edited.filter(g => g !== group);
            }
        },
        async saveActivityLogEmails() {
            this.group_message = '';
            if (this.edited.length > 0) {
                try {
                    await axios.post(`${this.$url}/log-status`,
                        {
                            user_id: this.user.user_id,
                            groups: this.edited
                        },
                        {
                            headers: {
                                Authorization: 'Bearer ' + getCookie('token'),
                                'Content-Type': 'application/json'
                            }
                        });
                    this.setAlertClass(true);
                    this.group_message = this.$t('success');
                    // Display message for 3 seconds, then erase the message
                    setTimeout(() => {
                        this.edited = [];
                        this.group_message = '';
                    }, 3000);
                } catch (error) {
                    this.setAlertClass(false);
                    this.group_message = this.$t('error') + ': ' + error.message;
                    // Display message for 3 seconds, then erase the message
                    setTimeout(() => {
                        this.group_message = '';
                    }, 3000);
                }
            }
        }
    },
    async mounted() {
        await this.fetchUserGroups(this.user);
    }
}
</script>

<style scoped>
/* Your styles here */
</style>